import NewFirmwareButton from "./newButton";
import NavBar from "../NavBar/NavBar";
import { firmwareData } from "../../settings/firmware";
import FirmwareReview from "./review";
import FirmwareAdvantages from "./advantages";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import { useCallback } from "react";
import FirmwareButton from "./button";

import styles from "../../styles/firmware/list.module.css";

import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import "./firmware.css";

export default function Firmware() {
  const isDoubleList = useCallback((arr) => {
    if (!Array.isArray(arr)) return false;
    if (arr.length === 0) return false;
    if (!!arr[0]?.links) return true;
    return false;
  }, []);

  const getDoubleLinks = useCallback(
    (el) => (
      <div className={styles.wrapper}>
        <NewFirmwareButton
          link={el.links?.sd}
          statistic={el?.statistic}
          text={"Скачать SD образ"}
        />
        <NewFirmwareButton
          link={el.links?.update}
          statistic={el?.statistic}
          text={"Скачать обновление"}
        />
      </div>
    ),
    []
  );

  const renderList = (arr = []) => {
    const isDouble = isDoubleList(arr);
    return arr.map((el, i) => (
      <div
        className={[
          "firmwareIMG",
          styles.row,
          isDouble ? styles.double : null,
        ].join(" ")}
        key={i}
      >
        <div className="firmwareIMGName">{el.title}</div>
        {el?.link && (
          <FirmwareButton
            link={process.env.REACT_APP_HOST + el.link}
            statistic={el.statistic}
          />
        )}
        {el?.links && getDoubleLinks(el)}
      </div>
    ));
  };

  const getListWithoutStatistic = useCallback((arr, newTab) => {
    if (!Array.isArray(arr)) return;
    return arr.map((value, index) => (
      <div className={"firmwareIMG"} key={index}>
        <div className="firmwareIMGName">{value.title}</div>
        {value?.link && <FirmwareButton link={value.link} newTab={!!newTab} />}
      </div>
    ));
  }, []);

  const renderInstruction = (arr = []) => {
    return arr.map((el, i) => (
      <div className="firmwareAdvantagesItem" key={i}>
        <div className="firmwareAdvantagesItemNumberWrapper">
          <div className="firmwareAdvantagesItemNumber">{i + 1}</div>
        </div>
        <div className="firmwareAdvantagesItemText">{el}</div>
      </div>
    ));
  };

  return (
    <>
      <NavBar />
      <div className="firmwareContainer">
        <div className="firmwareWrapper">
          {/* Header text */}
          <h1 className="firmwareH1">
            Представляем вам лучшие кастомные прошивки, которые существуют для
            асиков BITMAIN на сегодняшний день от разработчика MSK MINER
          </h1>
          <div className="firmwareContentContainer">
            {/* Advantages list */}
            <FirmwareAdvantages />
            {/* review */}
            <FirmwareReview />
          </div>
          <div className="firmwareContentContainer margin-top-3vw">
            <div className="firmwareContentSide ">
              {/* 19's */}
              <div className="firmwareIMGText">
                {firmwareData.nineteenth.headingA}
              </div>
              <div
                className={[
                  "firmwareIMGContainer",
                  styles.container,
                  styles.double,
                ].join(" ")}
              >
                {renderList(firmwareData.nineteenth.firmwareA)}
                <div className="firmwareVNISHText margin-top-2vw no-margin-bottom">
                  {firmwareData.nineteenth.headingB}
                </div>
                {renderList(firmwareData.nineteenth.firmwareB)}
                <div className="firmwareVNISHText margin-top-2vw no-margin-bottom">
                  {firmwareData.nineteenth.headingC}
                </div>
                {getListWithoutStatistic(
                  firmwareData.nineteenth.firmwareC,
                  true
                )}
              </div>
            </div>
            <div className="firmwareContentSide">
              <div className="firmwareIMGText">
                {firmwareData.nineteenth.instructionHeading}
              </div>
              <div className="firmwareAdvantagesItemsContainer">
                <div className="firmwareAdvantagesItemsIMG">
                  {renderInstruction(firmwareData.nineteenth.instruction)}
                </div>
              </div>
            </div>
          </div>
          <div className="firmwareContentContainer margin-top-4vw">
            <div className="firmwareContentSide">
              {/* Download HIVE ON */}
              <div className="firmwareIMGText">
                {firmwareData.hiveon.heading}
              </div>
              <div className="firmwareIMGContainer">
                {renderList(firmwareData.hiveon.firmware)}
              </div>
            </div>
            <div className="firmwareContentSide">
              <div className="firmwareIframes">
                <LiteYouTubeEmbed
                  id={"Dtwh75lBmoI"}
                  title={"Разгон асика Antminer S19 и T19 легко и быстро!"}
                  params={"start=58"}
                  wrapperClass={"yt-lite firmwareIframe"}
                  playerClass={"lty-playbtn firmwareIframe-playbtn"}
                />
              </div>
            </div>
          </div>
          <div className="firmwareContentContainer margin-top-4vw">
            <div className="firmwareContentSide">
              {/* Download .IMG */}
              <div className="firmwareIMGText">
                {firmwareData.seventeenth.heading}
              </div>
              <div className="firmwareIMGContainer">
                {renderList(firmwareData.seventeenth.firmware)}
              </div>
            </div>
            <div className="firmwareContentSide">
              <div className="firmwareIMGText">
                {firmwareData.seventeenth.instructionHeading}
              </div>
              <div className="firmwareAdvantagesItemsContainer">
                <div className="firmwareAdvantagesItemsIMG">
                  {renderInstruction(firmwareData.seventeenth.instruction)}
                </div>
              </div>
            </div>
          </div>
          <div className="firmwareContentContainer margin-top-4vw margin-bottom-4vw">
            <div className="firmwareContentSide">
              <div className="firmwareIMGText">
                {firmwareData.vnish.heading}
              </div>
              <div className="firmwareIMGContainer">
                {renderList(firmwareData.vnish.firmware)}
              </div>
              <div className="firmwareVNISHText margin-top-2vw">
                {firmwareData.vnish.headingB}
              </div>
              <div className="firmwareIMGText margin-top-2vw">
                {firmwareData.custom.heading}
              </div>
              <div className="firmwareIMGContainer">
                {renderList(firmwareData.custom.firmware)}
              </div>
              <div className="firmwareScreenContainer">
                <img
                  alt={"L3+ screenshot"}
                  src={`${process.env.PUBLIC_URL}assets/img/custom_l3+.png`}
                  width={384}
                  height={184}
                />
              </div>
              <div className="firmwareVNISHText">
                {firmwareData.custom.headingB}
              </div>
              <div className="firmwareIMGContainer">
                {getListWithoutStatistic(firmwareData.custom.firmwareB, false)}
              </div>
              <div className="firmwareVNISHText margin-top-1vw">
                {firmwareData.custom.headingC}
              </div>
            </div>
            <div className="firmwareContentSide">
              <div className="firmwareIMGText">{firmwareData.tar.heading}</div>
              <div className="firmwareIMGContainer">
                {renderList(firmwareData.tar.firmwareA)}
              </div>
              <div className="firmwareTAR">
                <div className="firmwareIMGContainer">
                  {renderList(firmwareData.tar.firmwareB)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
